import * as z from 'zod';

export const employeeFormSchema = (isEdit: boolean) =>
  z.object({
    name: z
      .string()
      .min(1, 'Tên nhân viên là bắt buộc')
      .max(30, 'Tên nhân viên không được vượt quá 30 ký tự')
      .refine(
        (val) => val.trim().length > 0,
        'Tên nhân viên không được chỉ chứa khoảng trắng'
      ),
    emailCreate: z.string().email('Email không hợp lệ'),
    passwordCreate: !isEdit
      ? z
          .string()
          .min(6, 'Mật khẩu phải có ít nhất 6 ký tự')
          .refine(
            (val) => val.trim().length > 0,
            'Mật khẩu không được chỉ chứa khoảng trắng'
          )
      : z.string().optional(),
    role: z.number().min(1, 'Vai trò là bắt buộc'),
    dateOfBirth: z
      .date({
        required_error: 'Ngày sinh là bắt buộc',
        invalid_type_error: 'Ngày sinh không hợp lệ',
      })
      .min(new Date('1900-01-01'), 'Ngày sinh không hợp lệ'),
    phoneNumber: z
      .string()
      .min(1, 'Số điện thoại là bắt buộc')
      .regex(/^(0[3|5|7|8|9])+([0-9]{8})\b$/, 'Số điện thoại không hợp lệ')
      .refine(
        (val) => val.trim().length > 0,
        'Số điện thoại không được chỉ chứa khoảng trắng'
      ),
    address: z
      .string()
      .min(1, 'Địa chỉ là bắt buộc')
      .refine(
        (val) => val.trim().length > 0,
        'Địa chỉ không được chỉ chứa khoảng trắng'
      ),
  });

export type EmployeeFormValues = z.infer<ReturnType<typeof employeeFormSchema>>;

export const REQUIRED_FIELDS = [
  'name',
  'email',
  'password',
  'role',
  'dateOfBirth',
  'phoneNumber',
  'address',
];
